import React, { useState } from 'react';
import './OurTeam.css';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';

import teamHeroCover from '../../assets/YOCILAB/DSC_7451.jpg';

// Team photos
import birndzeImg from '../../assets/img/team/Team/Birndze Bete Dzekewong - Founder and CEO.png';
import birlaImg from '../../assets/img/team/Team/Birla Charity Y. - Programs lead.png';
import abongkeImg from '../../assets/img/team/Team/Abongke Claire - Finance Manager.png';
import bamnjoImg from '../../assets/img/team/Team/Bamnjo Marilyn Leinyuy - Administrative Assistance.png';
import beltusImg from '../../assets/img/team/Team/Beltus Nkwawir - Mentorship Coordiantor.png';
import godloveImg from '../../assets/img/team/Team/Dr. Eng. Godlove Suila - Training Coridnator.png';
import kudakwasheImg from '../../assets/img/team/Team/Kudakwashe Foya - Partnership and proprams development manager.png';
import claudiaImg from '../../assets/img/team/Team/Njodzeka Claudia Berinyuy - Community Engagment officer.png';
import temitopeImg from '../../assets/img/team/Team/Temitope Lawal - Programs Asssociate.png';

// Advisors & Mentors
import alexImg from '../../assets/img/team/Team/Alex Balashov - Advisor.png';
import jasenImg from '../../assets/img/team/Team/Jasen Booton - Adisor.png';
import jasminImg from '../../assets/img/team/Team/Jasmin Cha - Advisor.png';
import salsabilaImg from '../../assets/img/team/Team/Salsabila Nurhidajat - Advisor.png';
import madjaliaImg from '../../assets/img/team/Madjalia Seynou - Mentor.png';
import lakshmyImg from '../../assets/img/team/Lakshmy Das - Trainer and  Mentor.png';

const leadershipTeam = [
  {
    name: "Birndze Bete Dzekewong",
    role: "Founder & Chief Executive Officer",
    category: "leadership",
    image: birndzeImg,
    bio: "Visionary social entrepreneur dedicated to unlocking the limitless creative and entrepreneurial potential of African youth.",
    tag: "Executive Leadership"
  },
  {
    name: "Birla Charity Youngyeh",
    role: "Programs Lead",
    category: "leadership",
    image: birlaImg,
    bio: "Passionate youth development strategist directing high-impact capacity building initiatives and summits across communities.",
    tag: "Programs"
  },
  {
    name: "Kudakwashe Foya",
    role: "Partnership & Programs Development Manager",
    category: "leadership",
    image: kudakwasheImg,
    bio: "Spearheading regional partnerships, stakeholder alliances, and strategic program scaling for sustainable impact.",
    tag: "Partnerships"
  },
  {
    name: "Abongke Claire",
    role: "Finance Manager",
    category: "leadership",
    image: abongkeImg,
    bio: "Overseeing financial governance, grant allocation, and operational efficiency across all organizational wings.",
    tag: "Operations"
  },
  {
    name: "Beltus Nkwawir",
    role: "Mentorship Coordinator & Trainer",
    category: "operations",
    image: beltusImg,
    bio: "Connecting aspiring youth innovators with industry experts, guiding cohort mentorship journeys, and facilitating masterclasses.",
    tag: "Mentorship"
  },
  {
    name: "Dr. Eng. Godlove Suila",
    role: "Training Coordinator & Technical Advisor",
    category: "operations",
    image: godloveImg,
    bio: "Designing curriculum frameworks and engineering hands-on technical learning experiences for emerging technology tracks.",
    tag: "Training"
  },
  {
    name: "Bamnjo Marilyn Leinyuy",
    role: "Administrative Assistant",
    category: "operations",
    image: bamnjoImg,
    bio: "Coordinating day-to-day organizational administration, logistics, and learner support services.",
    tag: "Administration"
  },
  {
    name: "Njodzeka Claudia Berinyuy",
    role: "Community Engagement Officer",
    category: "operations",
    image: claudiaImg,
    bio: "Fostering an inclusive, supportive, and active pan-African youth builder and alumni ecosystem.",
    tag: "Community"
  },
  {
    name: "Temitope Lawal",
    role: "Programs Associate & Mentor",
    category: "operations",
    image: temitopeImg,
    bio: "Facilitating youth training workshops and delivering hands-on mentorship across digital intelligence tracks.",
    tag: "Programs"
  }
];

const advisoryBoard = [
  {
    name: "Alex Balashov",
    role: "Board of Advisors",
    image: alexImg,
    bio: "Advising on global technology strategy, software systems, and international ecosystem expansion.",
    tag: "Strategy"
  },
  {
    name: "Jasen Booton",
    role: "Board of Advisors",
    image: jasenImg,
    bio: "Providing governance advisory, institutional partnership alignment, and social innovation guidance.",
    tag: "Governance"
  },
  {
    name: "Jasmin Cha",
    role: "Board of Advisors",
    image: jasminImg,
    bio: "Advising on organizational development, cross-cultural youth initiatives, and sustainable impact models.",
    tag: "Development"
  },
  {
    name: "Salsabila Nurhidajat",
    role: "Board of Advisors",
    image: salsabilaImg,
    bio: "Guiding educational curriculum design, human-centered program frameworks, and international youth advocacy.",
    tag: "Education"
  },
  {
    name: "Madjalia Seynou",
    role: "Youth Mentor & Innovation Coach",
    image: madjaliaImg,
    bio: "Empowering next-generation African founders through design thinking, venture ideation, and pitch coaching.",
    tag: "Mentorship"
  },
  {
    name: "Lakshmy Das",
    role: "Trainer & Technical Mentor",
    image: lakshmyImg,
    bio: "Delivering digital skill training, software engineering guidance, and career mentorship for tech builders.",
    tag: "Technical Training"
  }
];

const OurTeam = () => {
  const [filter, setFilter] = useState('all');

  const filteredMembers = filter === 'all' 
    ? leadershipTeam 
    : leadershipTeam.filter(m => m.category === filter);

  return (
    <div className="our-team-page">
      <SEO
        title="Our Team | YOCILAB"
        description="Meet the dedicated leaders, coordinators, and advisors driving youth transformation and innovation across Africa at YOCILAB."
      />

      {/* Hero Banner */}
      <section className="team-hero">
        <div className="team-hero__bg">
          <img src={teamHeroCover} alt="" className="team-hero__bg-img" />
          <div className="team-hero__overlay" />
        </div>
        <div className="container">
          <div className="team-hero__badge">
            <span className="team-hero__badge-dot" />
            THE PEOPLE BEHIND YOCILAB
          </div>
          <h1 className="team-hero__title">
            Passionate Changemakers<br />
            <em>Empowering Africa's Next Generation</em>
          </h1>
          <p className="team-hero__subtitle">
            Our diverse multidisciplinary team of educators, engineers, community builders, and international advisors work collaboratively to give young Africans the tools, mentorship, and opportunities to lead.
          </p>
        </div>
      </section>

      {/* Core Team Section */}
      <section className="team-section">
        <div className="container">
          <div className="team-section__header">
            <div>
              <span className="team-section__pill">CORE LEADERSHIP</span>
              <h2 className="team-section__title">Executive & Operations Team</h2>
            </div>
            
            <div className="team-filters">
              <button 
                className={`team-filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All Team ({leadershipTeam.length})
              </button>
              <button 
                className={`team-filter-btn ${filter === 'leadership' ? 'active' : ''}`}
                onClick={() => setFilter('leadership')}
              >
                Leadership
              </button>
              <button 
                className={`team-filter-btn ${filter === 'operations' ? 'active' : ''}`}
                onClick={() => setFilter('operations')}
              >
                Programs & Operations
              </button>
            </div>
          </div>

          <div className="team-grid">
            {filteredMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-card__image-wrap">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="team-card__image" 
                    loading="lazy"
                  />
                  <span className="team-card__tag">{member.tag}</span>
                </div>
                <div className="team-card__body">
                  <h3 className="team-card__name">{member.name}</h3>
                  <p className="team-card__role">{member.role}</p>
                  <p className="team-card__bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisory Board & Mentors */}
      <section className="advisors-section">
        <div className="container">
          <div className="team-section__header text-center">
            <span className="team-section__pill">GLOBAL GUIDANCE</span>
            <h2 className="team-section__title">Advisory Board & Mentors</h2>
            <p className="team-section__sub">
              Industry pioneers and academic leaders guiding YOCILAB's strategic expansion and impact excellence.
            </p>
          </div>

          <div className="advisors-grid">
            {advisoryBoard.map((advisor, index) => (
              <div key={index} className="advisor-card">
                <div className="advisor-card__avatar-wrap">
                  <img 
                    src={advisor.image} 
                    alt={advisor.name} 
                    className="advisor-card__avatar" 
                    loading="lazy"
                  />
                </div>
                <div className="advisor-card__content">
                  <span className="advisor-card__tag">{advisor.tag}</span>
                  <h3 className="advisor-card__name">{advisor.name}</h3>
                  <p className="advisor-card__role">{advisor.role}</p>
                  <p className="advisor-card__bio">{advisor.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Team Banner */}
      <section className="join-team-banner">
        <div className="container">
          <div className="join-team-box">
            <div className="join-team-content">
              <span className="join-team-badge">JOIN THE MOVEMENT</span>
              <h2>Want to make an impact with us?</h2>
              <p>
                We are always excited to welcome passionate trainers, mentors, ecosystem builders, and volunteers who want to empower youth across Africa.
              </p>
            </div>
            <div className="join-team-actions">
              <Link to="/contact" className="btn btn-primary">
                Get In Touch
              </Link>
              <Link to="/donate" className="btn btn-outline-white">
                Support Our Mission
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurTeam;